var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "properties-field",
      class: { "properties-field-group": _vm.isGroup },
      attrs: { id: _vm.id }
    },
    [
      _c("div", { staticClass: "wrap-properties" }, [
        _c("div", { staticClass: "properties-field-title" }, [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "close-properties",
              on: { click: _vm.closeConfiguration }
            },
            [_vm._v("\n        ×\n      ")]
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "properties-field-content properties-field-content-config"
          },
          [
            _c(
              "div",
              { staticClass: "section-field input-field" },
              [
                _c(
                  "b-form",
                  { class: { "error-input": _vm.$v.dataSetup.name.$error } },
                  [
                    _c("label", [_vm._v(" Name ")]),
                    _vm._v(" "),
                    _c("j-input", {
                      attrs: { placeholder: "Enter column name" },
                      model: {
                        value: _vm.dataSetup.name,
                        callback: function($$v) {
                          _vm.$set(_vm.dataSetup, "name", $$v)
                        },
                        expression: "dataSetup.name"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-form",
                  { class: { "error-input": _vm.$v.dataSetup.type.$error } },
                  [
                    _c("label", [_vm._v(" Format ")]),
                    _vm._v(" "),
                    _c("j-single-select", {
                      attrs: {
                        custom: true,
                        options: _vm.isDatasetSource
                          ? _vm.formatDatasetOptions
                          : _vm.formatOptions,
                        placeholder: "Select format"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "node-custom",
                          fn: function(node) {
                            return [
                              _c("img", {
                                staticStyle: {
                                  width: "14px",
                                  height: "auto",
                                  "margin-right": "5px"
                                },
                                attrs: {
                                  src: require("@/assets/icon/column-type/" +
                                    _vm.setIconType(node.node.id) +
                                    ".svg")
                                }
                              }),
                              _vm._v(
                                " " + _vm._s(node.node.label) + "\n            "
                              )
                            ]
                          }
                        }
                      ]),
                      model: {
                        value: _vm.dataSetup.type,
                        callback: function($$v) {
                          _vm.$set(_vm.dataSetup, "type", $$v)
                        },
                        expression: "dataSetup.type"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.dataSetup.type === "datetime" ||
                _vm.dataSetup.type === "time" ||
                _vm.dataSetup.type === "dd-mmm-yyyy" ||
                _vm.dataSetup.type === "mmmm dd, yyyy" ||
                _vm.dataSetup.type === "MMMM dd, yyyy"
                  ? _c(
                      "b-form",
                      [
                        _c("label", [_vm._v(" Timezone ")]),
                        _vm._v(" "),
                        _c("j-single-select", {
                          attrs: {
                            options: _vm.listTimezone,
                            placeholder: "Select Timezone",
                            label: "text",
                            "value-format": "object"
                          },
                          model: {
                            value: _vm.dataSetup.timezone,
                            callback: function($$v) {
                              _vm.$set(_vm.dataSetup, "timezone", $$v)
                            },
                            expression: "dataSetup.timezone"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.dataSetup.type !== "action_button" ? _c("hr") : _vm._e(),
                _vm._v(" "),
                _vm.dataSetup.type !== "action_button"
                  ? _c("h4", { staticClass: "title-section" }, [
                      _vm._v("Parse Value To")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.dataSetup.type !== "action_button"
                  ? _c(
                      "b-form",
                      { class: { "error-input": _vm.$v.dataSetup.key.$error } },
                      [
                        _c("label", [_vm._v(" Column ")]),
                        _vm._v(" "),
                        _c("j-single-select", {
                          attrs: {
                            options: _vm.variableOptionsFiltered,
                            placeholder: "Select variable",
                            disabled: !_vm.dataSetup.type
                          },
                          model: {
                            value: _vm.dataSetup.key,
                            callback: function($$v) {
                              _vm.$set(_vm.dataSetup, "key", $$v)
                            },
                            expression: "dataSetup.key"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _vm.dataSetup.type === "action_button"
              ? _c(
                  "div",
                  { staticClass: "section-field input-field" },
                  [
                    _c("h4", { staticClass: "title-section" }, [
                      _vm._v("Action Button")
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.dataSetup.action_buttons, function(item, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass: "container-action-button-table"
                        },
                        [
                          _vm._v(
                            "\n          " + _vm._s(item.label) + "\n          "
                          ),
                          _c("i", {
                            staticClass:
                              "fa fa-lg fa-trash pull-right cursor-pointer",
                            on: {
                              click: function($event) {
                                _vm.deleteActionButton(index, true)
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("i", {
                            staticClass:
                              "fa fa-lg fa-pencil-square-o pull-right cursor-pointer m__t--1",
                            on: {
                              click: function($event) {
                                _vm.openConfigActionButton(item, index)
                              }
                            }
                          })
                        ]
                      )
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "btn-add-config",
                        on: {
                          click: function($event) {
                            _vm.openConfigActionButton(null, null)
                          }
                        }
                      },
                      [_vm._v("\n          + Add Action Button\n        ")]
                    )
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.dataSetup.type !== "action_button"
              ? _c(
                  "div",
                  { staticClass: "section-field input-field" },
                  [
                    _c("h4", { staticClass: "title-section" }, [
                      _vm._v("Configuration")
                    ]),
                    _vm._v(" "),
                    _vm.dataSetup.type === "text" &&
                    _vm.parseValueTimer &&
                    _vm.type !== "export"
                      ? _c(
                          "b-form",
                          [
                            _c("label", [_vm._v(" Timezone ")]),
                            _vm._v(" "),
                            _c("j-single-select", {
                              attrs: {
                                options: _vm.listTimezone,
                                placeholder: "Select Timezone",
                                label: "text",
                                "value-format": "object"
                              },
                              model: {
                                value: _vm.dataSetup.timezone,
                                callback: function($$v) {
                                  _vm.$set(_vm.dataSetup, "timezone", $$v)
                                },
                                expression: "dataSetup.timezone"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.type === "export" && _vm.useFilter
                      ? _c("div", { staticClass: "configuration-section" }, [
                          _c(
                            "div",
                            { staticClass: "configuration-toggle-in-title" },
                            [
                              _vm._m(1),
                              _vm._v(" "),
                              _c("j-switch", {
                                model: {
                                  value: _vm.dataSetup.is_filter,
                                  callback: function($$v) {
                                    _vm.$set(_vm.dataSetup, "is_filter", $$v)
                                  },
                                  expression: "dataSetup.is_filter"
                                }
                              })
                            ],
                            1
                          )
                        ])
                      : _vm.useFilter
                      ? _c("div", { staticClass: "configuration-section" }, [
                          _c(
                            "div",
                            { staticClass: "configuration-toggle-in-title" },
                            [
                              _vm._m(2),
                              _vm._v(" "),
                              _c("j-switch", {
                                model: {
                                  value: _vm.dataSetup.sort,
                                  callback: function($$v) {
                                    _vm.$set(_vm.dataSetup, "sort", $$v)
                                  },
                                  expression: "dataSetup.sort"
                                }
                              })
                            ],
                            1
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.dataSetup.type !== "progress_bar"
                      ? _c("div", { staticClass: "configuration-section" }, [
                          _c(
                            "h4",
                            { staticClass: "configuration-section-title" },
                            [_vm._v("Content Alignment")]
                          ),
                          _vm._v(" "),
                          _c(
                            "p",
                            { staticClass: "configuration-section-desc" },
                            [
                              _vm._v(
                                "\n            Where and how the text lines up\n          "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "wrap-alignment" },
                            _vm._l(_vm.contentAlignment, function(align) {
                              return _c(
                                "div",
                                {
                                  key: align.type,
                                  staticClass: "alignment-block",
                                  class: {
                                    "alignment-active":
                                      _vm.dataSetup.content_alignment ===
                                      align.type
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.changeAlignment(align.type)
                                    }
                                  }
                                },
                                [
                                  _vm.dataSetup.content_alignment !== align.type
                                    ? _c("img", {
                                        attrs: {
                                          src: require("@/assets/icon/column-alignment/" +
                                            align.type +
                                            ".svg"),
                                          alt: "align-" + align.type
                                        }
                                      })
                                    : _c("img", {
                                        attrs: {
                                          src: require("@/assets/icon/column-alignment/" +
                                            (align.type + "-blue") +
                                            ".svg"),
                                          alt: "align-" + align.type
                                        }
                                      })
                                ]
                              )
                            })
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.dataSetup.type === "currency"
                      ? _c("div", { staticClass: "configuration-section" }, [
                          _c(
                            "div",
                            { staticClass: "configuration-toggle-in-title" },
                            [
                              _vm._m(3),
                              _vm._v(" "),
                              _c("j-switch", {
                                model: {
                                  value: _vm.dataSetup.allow_minus_value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.dataSetup,
                                      "allow_minus_value",
                                      $$v
                                    )
                                  },
                                  expression: "dataSetup.allow_minus_value"
                                }
                              })
                            ],
                            1
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.dataSetup.type === "currency"
                      ? _c(
                          "div",
                          { staticClass: "configuration-section" },
                          [
                            _c(
                              "b-form",
                              {
                                class: {
                                  "error-input":
                                    _vm.$v.dataSetup.default_currency.$error
                                }
                              },
                              [
                                _c("label", [_vm._v(" Default Currency ")]),
                                _vm._v(" "),
                                _c("j-single-select", {
                                  attrs: {
                                    options: _vm.list_currency,
                                    label: "symbol_name",
                                    placeholder: "Select Default Currency"
                                  },
                                  model: {
                                    value:
                                      _vm.$v.dataSetup.default_currency.$model,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.$v.dataSetup.default_currency,
                                        "$model",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "$v.dataSetup.default_currency.$model"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "field-information" }, [
                              _vm._v(
                                "\n            The default currency is the value currency specified in the field value attribute\n          "
                              )
                            ])
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.dataSetup.type === "progress_bar"
                      ? _c(
                          "div",
                          { staticClass: "configuration-section" },
                          [
                            _c(
                              "h4",
                              { staticClass: "configuration-section-title" },
                              [_vm._v("Color")]
                            ),
                            _vm._v(" "),
                            _c(
                              "p",
                              { staticClass: "configuration-section-desc" },
                              [
                                _vm._v(
                                  "\n            Custom appearance for progress bar\n          "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("j-color-picker", {
                              attrs: {
                                color: _vm.dataSetup.color,
                                label: "Color",
                                picker: "chrome"
                              },
                              model: {
                                value: _vm.dataSetup.color,
                                callback: function($$v) {
                                  _vm.$set(_vm.dataSetup, "color", $$v)
                                },
                                expression: "dataSetup.color"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.type === "table_view" && _vm.isUseEditable
                      ? _c("div", { staticClass: "configuration-section" }, [
                          _c(
                            "div",
                            { staticClass: "configuration-toggle-in-title" },
                            [
                              _vm._m(4),
                              _vm._v(" "),
                              _c("j-switch", {
                                model: {
                                  value: _vm.dataSetup.is_editable_column,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.dataSetup,
                                      "is_editable_column",
                                      $$v
                                    )
                                  },
                                  expression: "dataSetup.is_editable_column"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.dataSetup.is_editable_column
                            ? _c("div", [
                                !_vm.dataSetup.editable_column
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "btn-add-config",
                                        on: { click: _vm.openModalFieldLibrary }
                                      },
                                      [
                                        _vm._v(
                                          "\n              + Add Field\n            "
                                        )
                                      ]
                                    )
                                  : _c(
                                      "div",
                                      {
                                        staticClass: "field-list mb-0",
                                        class: { selected: _vm.showProperties }
                                      },
                                      [
                                        _c(
                                          "p",
                                          { staticClass: "column-name" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.dataSetup.editable_column
                                                  .name || "Field Name"
                                              )
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("field-preview", {
                                          attrs: {
                                            column:
                                              _vm.dataSetup.editable_column
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "edit-or-delete" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "button" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "edit",
                                                    on: { click: _vm.editField }
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "fa fa-pencil-square-o"
                                                    })
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "delete",
                                                    on: {
                                                      click: _vm.deleteField
                                                    }
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass: "fa fa-trash"
                                                    })
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                              ])
                            : _vm._e()
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.dataSetup.type === "text" &&
                    _vm.variableType === "object"
                      ? _c(
                          "div",
                          { staticClass: "configuration-section" },
                          [
                            _c(
                              "div",
                              { staticClass: "configuration-toggle-in-title" },
                              [
                                _vm._m(5),
                                _vm._v(" "),
                                _c("j-switch", {
                                  model: {
                                    value:
                                      _vm.dataSetup.is_use_direct_open_detail,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.dataSetup,
                                        "is_use_direct_open_detail",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "dataSetup.is_use_direct_open_detail"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.dataSetup.is_use_direct_open_detail
                              ? _c(
                                  "b-form",
                                  {
                                    class: {
                                      "error-input":
                                        _vm.$v.dataSetup.form_ui_id.$error
                                    }
                                  },
                                  [
                                    _c("label", [
                                      _vm._v(" Experience Manager")
                                    ]),
                                    _vm._v(" "),
                                    _c("j-single-select", {
                                      attrs: {
                                        "load-options": _vm.loadOptionsFormUI,
                                        "is-async": true,
                                        "cache-option": false,
                                        placeholder: "Experience Manager",
                                        "value-format": "object",
                                        label: "name"
                                      },
                                      model: {
                                        value: _vm.dataSetup.form_ui_id,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.dataSetup,
                                            "form_ui_id",
                                            $$v
                                          )
                                        },
                                        expression: "dataSetup.form_ui_id"
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e()
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "properties-field-button",
            class: { "justify-content-end": !_vm.fieldDetail }
          },
          [
            _vm.fieldDetail
              ? _c(
                  "button",
                  {
                    staticClass: "button-border",
                    on: { click: _vm.deleteConfiguration }
                  },
                  [
                    _c("i", { staticClass: "fa fa-trash" }),
                    _vm._v(" Delete\n      ")
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "d-flex align-items-center" }, [
              _c(
                "button",
                {
                  staticClass: "button-border mr-2",
                  on: { click: _vm.closeConfiguration }
                },
                [_vm._v("\n          Close\n        ")]
              ),
              _vm._v(" "),
              _c(
                "button",
                { staticClass: "button-blue", on: { click: _vm.submitForm } },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.fieldDetail ? "Update" : "Add") +
                      "\n        "
                  )
                ]
              )
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _vm.isOpenConfigActionBtn
        ? _c("action-button-configuration", {
            attrs: {
              id: _vm.idConfigActionBtn,
              "field-detail": _vm.selectedBtn,
              "on-table": true,
              "variable-options": _vm.variableOptions,
              "list-function": _vm.listFunction
            },
            on: {
              "close-configuration": function($event) {
                _vm.toggleConfigurationActionBtn(false)
              },
              "delete-action-button": _vm.deleteActionButton,
              "submit-configuration": _vm.submitActionButton
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showProperties
        ? _c("properties-field", {
            ref: _vm.idProperties,
            attrs: {
              id: [_vm.idProperties],
              "field-detail": _vm.dataSetup.editable_column,
              "is-group": true,
              "is-new-field": _vm.isNewField,
              "is-table-editable": true
            },
            on: {
              "delete-field": _vm.deleteField,
              "close-properties": function($event) {
                _vm.togglePropertiesField(false)
              },
              "submit-mode": _vm.submitField
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h4", { staticClass: "title" }, [
      _vm._v("\n        Properties\n        "),
      _c("div", { staticClass: "title-badge" }, [_vm._v("Column")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wrap-title" }, [
      _c("h4", { staticClass: "configuration-section-title" }, [
        _vm._v("Show as search column result")
      ]),
      _vm._v(" "),
      _c("h4", { staticClass: "configuration-section-desc mb-0" }, [
        _vm._v(
          "This column will be displayed on the table of the search results"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wrap-title" }, [
      _c("h4", { staticClass: "configuration-section-title mb-0" }, [
        _vm._v("Sort")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wrap-title" }, [
      _c("h4", { staticClass: "configuration-section-title m-0" }, [
        _vm._v("Allow Minus Value")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "configuration-section-desc" }, [
        _vm._v(
          "\n                Show currency in brackets as minus value sign\n              "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wrap-title" }, [
      _c("h4", { staticClass: "configuration-section-title" }, [
        _vm._v("Editable")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "configuration-section-desc" }, [
        _vm._v(
          "\n                Allow edit action and update data in table column\n              "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wrap-title" }, [
      _c("h4", { staticClass: "configuration-section-title m-0" }, [
        _vm._v("Direct Open Detail")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "configuration-section-desc" }, [
        _vm._v(
          "\n                Show currency in brackets as minus value sign\n              "
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-97aec5d8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-97aec5d8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/experience-manager-v2/partials/configuration/ColumnConfiguration.vue
// module id = null
// module chunks = 